import BaseService from "./baseService";

export class ContainerService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/containers";
    this.name = "Containers";
  }

  getListUrl(body) {

    return this.post(this.url + "/get-list-url", JSON.stringify(body));
  }

  async getFiles(location) {
    let url = this.url + "/" + location + "/files";
    return await this.get(url);
  }
  downloadLink(location, file) {
    return this.url + "/" + location + "/download/" + file;
  }
  createOrReturn(location) {
    let url = this.url;
    let self = this;
    if (location === "") return false;
    url += "/" + location;
    return this.get(url).then(function(result) {
      if (result.hasOwnProperty("error")) {
        return self.post(self.url, JSON.stringify({ name: location }));
      }
      return result;
    });
  }
  upload(file, location, name = null) {
    let self = this;
    //let url = this.url + "/" + location + "/upload";
    let url = '/' + location + '/picture/' + name;
    return this.createOrReturn(location).then(function(container) {

      const formData = new FormData();
      formData.append("file", file, name);
      return self.postFile(url, formData);
    });
  }

  postFile(url, body) {
    return fetch(`${this.BASE_URL}` + url, {
      method: "POST",
      withCredentials: true,
      body: body,
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${localStorage.getItem("id-tkn")}`
      }
    }).then(resp => resp.json());
  }
}

export default ContainerService;
